import projects_overlays from '../projects_overlays/projects_overlays'
import { utility_controller, Utility } from '../utility/utility_controller'

var cover_controller = {
	i: function () {
		i()
	},
}

export default cover_controller

var jqueryMap = {
	$cover: null,
}

// Cover can exist in two scroll contexts: the normal page (`body`) and a
// project overlay (`#lay-project-overlay`). Do not infer the active context
// from global overlay visibility in later resize/click/scroll callbacks:
// during project-overlay open/close, body and overlay DOM can briefly coexist.
// `newpageshown` tells us which scope is being initialized, so store that
// scope and reuse it until the next `newpageshown`.
var currentParentSelector = 'body>.lay-content'
var currentIsProjectOverlay = false

var stateMap = {
	doDarken: false,
	doParallax: false,
	enabled: false,
	frame: false,
	lastClientX: null,
	lastClientY: null,
}

var clamp = function (value, min, max) {
	value = parseFloat(value)
	if (isNaN(value)) {
		return min
	}
	return Math.max(min, Math.min(max, value))
}

var getDeviceOption = function (desktopOptionName, phoneOptionName) {
	return Utility.isPhoneSize ? layData[phoneOptionName] : layData[desktopOptionName]
}

var ensureCoverDownArrowSvgViewBoxes = function (parent) {
	var scope = parent || document
	jQuery(scope)
		.find('svg.cover-down-arrow-desktop')
		.each(function () {
			if (!this.getAttribute('viewBox')) {
				this.setAttribute('viewBox', '0 0 48 24')
				this.setAttribute('preserveAspectRatio', 'xMidYMid meet')
			}
		})
	jQuery(scope)
		.find('svg.cover-down-arrow-phone')
		.each(function () {
			if (!this.getAttribute('viewBox')) {
				this.setAttribute('viewBox', '0 0 36 20')
				this.setAttribute('preserveAspectRatio', 'xMidYMid meet')
			}
		})
}

var i = function () {
	if (layData.misc_options_cover == 'on') {
		stateMap.enabled = true

		if (layData.cover_darken_when_scrolling == 'on') {
			stateMap.doDarken = true
		}
		if (layData.cover_parallaxmove_when_scrolling == 'on') {
			stateMap.doParallax = true
		}

		window.laytheme.on('newpageshown', function (layoutObj, type, obj, isProjectOverlayObj) {
			unbindScroll()
			currentIsProjectOverlay = isProjectOverlayObj != undefined && isProjectOverlayObj.isProjectOverlay === true
			currentParentSelector = currentIsProjectOverlay ? '#lay-project-overlay>.lay-content' : 'body>.lay-content'
			var parent = currentParentSelector
			ensureCoverDownArrowSvgViewBoxes(jQuery(parent)[0])
			jqueryMap.$cover = jQuery(parent + ' .cover-region')
			if (jqueryMap.$cover.length > 0) {
				bindBreakpointChanged()
				// see if maybe cover is disabled for phone
				if (Utility.isPhoneSize && layData.cover_disable_for_phone == true) {
					stateMap.enabled = false
				} else {
					stateMap.enabled = true
				}
				bindCoverClick()
				bindCoverArrowClick()
				resetHeights()
				setCoverHeightAndPosition()
				bindResize()
				bindScroll()
			}
		})
	}
}

// switched from desktop to tablet to phone?
var enableOrDisableForDesktopOrPhone = function (size) {
	var parent = currentParentSelector

	switch (size) {
		case 'desktop':
		case 'tablet':
			if (layData.cover_disable_for_phone == true && stateMap.enabled == false) {
				// enable
				stateMap.enabled = true
				bindCoverClick()
				bindCoverArrowClick()
				bindScroll()
			}
			break
		case 'phone':
			// disable
			if (layData.cover_disable_for_phone == true) {
				stateMap.enabled = false
				// remove styles for parallax, darken
				jqueryMap.$cover.attr('style', '')
				// reset cover
				jQuery(parent + ' .cover-region').removeClass('clickable-cover')
				jQuery(parent + ' .cover-region').off('click')
				unbindCoverDomCursor()
				jQuery(parent + ' .cover-down-arrow-desktop, ' + parent + ' .cover-down-arrow-phone').removeClass('clickable-cover-arrow')
				jQuery(parent + ' .cover-down-arrow-desktop, ' + parent + ' .cover-down-arrow-phone').css('cursor', '')
				jQuery(parent + ' .cover-down-arrow-desktop, ' + parent + ' .cover-down-arrow-phone').off('click')
				//
				unbindScroll()
			}
			break
	}
}

var bindResize = function () {
	jQuery(window).off('window_width_changed', doResize)
	jQuery(window).on('window_width_changed', doResize)
}

var bindBreakpointChanged = function () {
	window.laytheme.off('sizechanged', enableOrDisableForDesktopOrPhone)
	window.laytheme.on('sizechanged', enableOrDisableForDesktopOrPhone)
}

var doResize = function () {
	// enableOrDisableCover();
	setCoverHeightAndPosition()
}

var resetHeights = function () {
	var parent = currentParentSelector

	jQuery(parent + ' .cover-region').css({
		top: '',
		height: '',
		'min-height': '',
	})
	jQuery(parent + ' .cover-region .row, ' + parent + ' .cover-region .row-inner, ' + parent + ' .cover-region .column-wrap, ' + parent + ' .cover-inner').css({
		height: '',
		'min-height': '',
	})
}

var getCoverHeightCSS = function (device) {
	var mode = layData['cover_height_mode_' + device] || '100svh'
	switch (mode) {
		case '100lvh':
			return '100lvh'
		case '100svh':
		default:
			return '100svh'
	}
}

var setCoverHeightAndPosition = function () {
	if (jqueryMap.$cover.is(':visible') && stateMap.enabled && Utility.isPhoneSize) {
		var h = jQuery('.navbar').height()
		if (!jQuery('.navbar').is(':visible')) {
			h = 0
		}
		var parent = currentParentSelector
		var phoneHeightCSS = getCoverHeightCSS('phone')
		var adjustedPhoneHeightCSS = 'calc(' + phoneHeightCSS + ' - ' + h + 'px)'

		jQuery(parent + ' .cover-region').css({
			top: h + 'px',
			height: adjustedPhoneHeightCSS,
			'min-height': adjustedPhoneHeightCSS,
		})
		jQuery(parent + ' .cover-region .row, ' + parent + ' .cover-region .row-inner, ' + parent + ' .cover-region .column-wrap, ' + parent + ' .cover-inner').css({
			height: adjustedPhoneHeightCSS,
			'min-height': adjustedPhoneHeightCSS,
		})
	} else if (jqueryMap.$cover.is(':visible') && stateMap.enabled) {
		var desktopHeightCSS = getCoverHeightCSS('desktop')
		var desktopParent = currentParentSelector
		jQuery(desktopParent + ' .cover-region').css({
			top: '',
			height: desktopHeightCSS,
			'min-height': desktopHeightCSS,
		})
		jQuery(desktopParent + ' .cover-region .row, ' + desktopParent + ' .cover-region .row-inner, ' + desktopParent + ' .cover-region .column-wrap, ' + desktopParent + ' .cover-inner').css({
			height: desktopHeightCSS,
			'min-height': desktopHeightCSS,
		})
	} else {
		resetHeights()
	}
}

var unbindScroll = function () {
	window.eventsChannel.off('scroll', doScroll)
	// cancelAnimationFrame(stateMap.frame)
}

var bindScroll = function () {
	window.eventsChannel.off('scroll', doScroll)
	window.eventsChannel.on('scroll', doScroll)
	// cancelAnimationFrame(stateMap.frame)
	// stateMap.frame = requestAnimationFrame(doScroll)
}

// todo: maybe use animationframe instead of just setting the brightnes css when you scroll? maybe this will be smoother on iphone
// test

var doScroll = function (scrollTop, scrollHeight, scrollContext) {
	if (scrollContext && scrollContext.source === 'page-overlay') {
		return
	}
	var isProjectOverlayOpen = window.laytheme && typeof window.laytheme.isProjectOverlayOpen === 'function' && window.laytheme.isProjectOverlayOpen()
	if (!scrollContext && !currentIsProjectOverlay && isProjectOverlayOpen) {
		return
	}
	if (scrollContext && currentIsProjectOverlay && scrollContext.source !== 'project-overlay') {
		return
	}
	if (scrollContext && !currentIsProjectOverlay && scrollContext.source === 'project-overlay') {
		return
	}
	var y = scrollTop
	// if (y <= window.innerHeight && jqueryMap.$cover.is(':visible') && stateMap.enabled) {
	if (y <= window.innerHeight && stateMap.enabled) {
		// Darken targets .cover-region (not .cover-inner) so the cover background
		// dims with the content. The global/customizer background colour sits on
		// .cover-region while only a per-page background sits on .cover-inner —
		// dimming the region covers both, matches the `will-change: filter` hint
		// in cover.scss, and leaves no undimmed seam when parallax shifts the
		// inner content up.
		if (stateMap.doDarken) {
			var darkenAmount = clamp(layData.cover_darken_when_scrolling_amount, 0, 100)
			var minBrightness = 1 - darkenAmount / 100
			var brightness = utility_controller.map(y, 0, window.innerHeight, 1, minBrightness)
			if (brightness > 1) {
				brightness = 1
			}
			jqueryMap.$cover.css({
				filter: 'brightness(' + brightness + ')',
				'-webkit-filter': 'brightness(' + brightness + ')',
			})
		}
		if (stateMap.doParallax) {
			var parallaxAmount = clamp(layData.cover_parallaxmove_when_scrolling_amount, 0, 100)
			var translate = utility_controller.map(y, 0, window.innerHeight, 0, window.innerHeight * (parallaxAmount / 100))
			jqueryMap.$cover.find('.cover-inner').css({
				transform: 'translate3d(0,-' + translate + 'px, 0)',
				'-webkit-transform': 'translate3d(0,-' + translate + 'px, 0)',
			})
		}
	}
	// requestAnimationFrame(doScroll)
}

var getScrollOffset = function () {
	return parseFloat(getDeviceOption('cover_scrolldown_offset_desktop', 'cover_scrolldown_offset_phone')) || 0
}

var isEnabledValue = function (value) {
	return value === true || value === 1 || value === '1' || value === 'on'
}

var shouldEnableCoverDomCursor = function () {
	return layData.cover_down_cursor_active == 'on' && isEnabledValue(layData.cover_down_cursor_use_dom_cursor)
}

var shouldUseCoverDomCursor = function () {
	return shouldEnableCoverDomCursor() && window.layDomCursor
}

var getCurrentPageScrollTop = function ($page) {
	if (currentIsProjectOverlay) {
		return jQuery('#lay-project-overlay').scrollTop()
	}
	if (typeof window !== 'undefined') {
		return window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || $page.scrollTop()
	}
	return $page.scrollTop()
}

var getCoverAnimationDuration = function () {
	var duration = parseInt(layData.cover_animation_duration, 10)
	if (isNaN(duration) || duration < 0) {
		return 0
	}
	return duration
}

var getCoverAnimationEasing = function () {
	var easingName = layData.cover_animation_easing
	if (typeof jQuery.easing === 'object' && typeof jQuery.easing[easingName] === 'function') {
		return function (t) {
			return jQuery.easing[easingName](t, t, 0, 1, 1)
		}
	}
	return function (t) {
		return t
	}
}

var getBodyLenis = function () {
	if (currentIsProjectOverlay || typeof window === 'undefined') {
		return null
	}
	if (!window.smooth_scroll_controller || typeof window.smooth_scroll_controller.getInstance !== 'function') {
		return null
	}
	var bodyLenis = window.smooth_scroll_controller.getInstance()
	if (!bodyLenis || bodyLenis.isStopped || typeof bodyLenis.scrollTo !== 'function') {
		return null
	}
	return bodyLenis
}

var getCoverDownCursorAsset = function () {
	return layData.cover_down_cursor || null
}

var getEventClientPosition = function (event) {
	var originalEvent = event && event.originalEvent ? event.originalEvent : event
	return {
		x: originalEvent && originalEvent.clientX != null ? originalEvent.clientX : null,
		y: originalEvent && originalEvent.clientY != null ? originalEvent.clientY : null,
	}
}

var isNativeCursorTarget = function (event) {
	var position = getEventClientPosition(event)
	var target = event && event.target ? event.target : null
	if (target && target.closest && target.closest('a, button, input, textarea, select, label, video, [role="button"]')) {
		return true
	}
	if (position.x !== null && position.y !== null) {
		var elAtPoint = document.elementFromPoint(position.x, position.y)
		if (elAtPoint && elAtPoint.closest && elAtPoint.closest('a, button, input, textarea, select, label, video, [role="button"]')) {
			return true
		}
	}
	return false
}

var updateCoverDomCursor = function (event) {
	if (!shouldUseCoverDomCursor()) {
		return
	}
	if (isNativeCursorTarget(event)) {
		hideCoverDomCursor()
		return
	}
	var asset = getCoverDownCursorAsset()
	var position = getEventClientPosition(event)
	if (!asset || position.x === null || position.y === null) {
		return
	}
	stateMap.lastClientX = position.x
	stateMap.lastClientY = position.y
	window.layDomCursor.setContext('cover', {
		priority: 15,
		src: asset.src,
		hotspotX: asset.hotspotX,
		hotspotY: asset.hotspotY,
		width: asset.width,
		height: asset.height,
		x: position.x,
		y: position.y,
	})
}

var hideCoverDomCursor = function () {
	if (window.layDomCursor) {
		window.layDomCursor.hideContext('cover')
	}
}

var refreshCoverDomCursorFromLastPointer = function () {
	if (!shouldUseCoverDomCursor() || stateMap.lastClientX === null || stateMap.lastClientY === null) {
		hideCoverDomCursor()
		return
	}
	var elAtPoint = document.elementFromPoint(stateMap.lastClientX, stateMap.lastClientY)
	if (!elAtPoint || !elAtPoint.closest || !elAtPoint.closest(currentParentSelector + ' .cover-region.clickable-cover')) {
		hideCoverDomCursor()
		return
	}
	updateCoverDomCursor({
		target: elAtPoint,
		clientX: stateMap.lastClientX,
		clientY: stateMap.lastClientY,
	})
}

var unbindCoverDomCursor = function () {
	var parent = currentParentSelector
	jQuery(parent + ' .cover-region').removeClass('cover-dom-cursor-enabled').off('.layCoverDomCursor')
	jQuery(document).off('mousemove.layCoverDomCursorGlobal')
	jQuery(window).off('layDomCursorReady.layCoverDomCursorReady')
	jQuery(window).off('scroll.layCoverDomCursor resize.layCoverDomCursor')
	stateMap.lastClientX = null
	stateMap.lastClientY = null
	hideCoverDomCursor()
}

var bindCoverDomCursor = function () {
	var parent = currentParentSelector
	var $cover = jQuery(parent + ' .cover-region')
	unbindCoverDomCursor()
	if (!shouldUseCoverDomCursor()) {
		if (shouldEnableCoverDomCursor()) {
			jQuery(window).one('layDomCursorReady.layCoverDomCursorReady', bindCoverDomCursor)
		}
		return
	}
	$cover.addClass('cover-dom-cursor-enabled')
	jQuery(document).on('mousemove.layCoverDomCursorGlobal', function (event) {
		stateMap.lastClientX = event.clientX
		stateMap.lastClientY = event.clientY
	})
	$cover
		.on('mouseenter.layCoverDomCursor', updateCoverDomCursor)
		.on('mousemove.layCoverDomCursor', updateCoverDomCursor)
		.on('mouseleave.layCoverDomCursor', hideCoverDomCursor)
	jQuery(window).on('scroll.layCoverDomCursor resize.layCoverDomCursor', refreshCoverDomCursorFromLastPointer)
}

var scrollDownFromCover = function () {
	var parent = currentParentSelector
	var $page = currentIsProjectOverlay ? jQuery('#lay-project-overlay') : jQuery('html, body')

	var $coverContentDesktop = jQuery(parent + ' .cover-content-desktop')
	var targetScrollPos
	if ($coverContentDesktop.length > 0) {
		targetScrollPos = $coverContentDesktop[0].getBoundingClientRect().top + 1
	} else {
		var $coverRegion = jQuery(parent + ' .cover-region:visible').first()
		targetScrollPos = $coverRegion.length > 0 ? $coverRegion[0].getBoundingClientRect().bottom + 1 : 0
	}
	var currentDevice = Utility.screenSize
	if (currentDevice == 'phone') {
		var $coverContentPhone = jQuery(parent + ' .cover-content-phone')
		if ($coverContentPhone.length > 0) {
			targetScrollPos = $coverContentPhone[0].getBoundingClientRect().top + 1
		}
		var navbarHeight = jQuery('.navbar').height()
		if (!jQuery('.navbar').is(':visible')) {
			navbarHeight = 0
		}
		targetScrollPos -= navbarHeight
	}
	targetScrollPos -= getScrollOffset()

	var currentScrollTop = getCurrentPageScrollTop($page)
	targetScrollPos += currentScrollTop
	targetScrollPos = Math.max(targetScrollPos, currentScrollTop)

	var duration = getCoverAnimationDuration()
	var bodyLenis = getBodyLenis()
	if (bodyLenis) {
		$page.stop(true)
		bodyLenis.scrollTo(targetScrollPos, {
			duration: duration / 1000,
			easing: getCoverAnimationEasing(),
		})
		return
	}

	$page.stop(true)
	$page.animate({ scrollTop: targetScrollPos }, duration, layData.cover_animation_easing, function () {
		if (!currentIsProjectOverlay) {
			$page.off('scroll mousedown wheel DOMMouseScroll mousewheel keyup touchmove', stopAnimation)
		}
	})
	if (!currentIsProjectOverlay) {
		$page.on('scroll mousedown wheel DOMMouseScroll mousewheel keyup touchmove', $page, stopAnimation)
	}
}

var bindCoverClick = function () {
	var parent = currentParentSelector
	jQuery(parent + ' .cover-region').removeClass('clickable-cover')
	jQuery(parent + ' .cover-region').off('click')
	unbindCoverDomCursor()

	if (layData.cover_scrolldown_on_click == 'on' && stateMap.enabled) {
		jQuery(parent + ' .cover-region').addClass('clickable-cover')
		jQuery(parent + ' .cover-region').on('click', function () {
			scrollDownFromCover()
		})
		bindCoverDomCursor()
	}
}

var bindCoverArrowClick = function () {
	var parent = currentParentSelector
	var $arrows = jQuery(parent + ' .cover-down-arrow-desktop, ' + parent + ' .cover-down-arrow-phone')
	$arrows.removeClass('clickable-cover-arrow')
	$arrows.css('cursor', '')
	$arrows.off('click')

	if (layData.cover_scrolldown_on_arrow_click == 'on' && stateMap.enabled) {
		$arrows.addClass('clickable-cover-arrow')
		$arrows.css('cursor', 'pointer')
		$arrows.on('click', function (event) {
			event.preventDefault()
			event.stopPropagation()
			scrollDownFromCover()
		})
	}
}

var stopAnimation = function (event) {
	event.data.stop()
}
